import { render, staticRenderFns } from "./NoticeIntro.vue?vue&type=template&id=3fcb2085"
import script from "./NoticeIntro.vue?vue&type=script&lang=js"
export * from "./NoticeIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports